import { detectPlatform, shouldShowInstallHint } from './platform';

const DISMISS_KEY = 'install-hint-dismissed';

/** Ecranul de start: AudioContext și senzorii se pot porni doar după o atingere. */
export function waitForStart(button: HTMLButtonElement, screen: HTMLElement): Promise<AudioContext | null> {
  return new Promise((resolve) => {
    button.addEventListener(
      'click',
      () => {
        let audio: AudioContext | null = null;
        try {
          const AC = window.AudioContext || (window as unknown as { webkitAudioContext?: typeof AudioContext }).webkitAudioContext;
          if (AC) {
            audio = new AC({ latencyHint: 'interactive' });
            void audio.resume();
            // un clic scurt confirmă că sunetul e deblocat
            const o = audio.createOscillator();
            const g = audio.createGain();
            o.frequency.value = 880;
            g.gain.setValueAtTime(0.0001, audio.currentTime);
            g.gain.exponentialRampToValueAtTime(0.08, audio.currentTime + 0.01);
            g.gain.exponentialRampToValueAtTime(0.0001, audio.currentTime + 0.12);
            o.connect(g).connect(audio.destination);
            o.start();
            o.stop(audio.currentTime + 0.15);
          }
        } catch {
          audio = null;
        }
        screen.hidden = true;
        resolve(audio);
      },
      { once: true }
    );
  });
}

/** Instrucțiunile „Adaugă la ecranul principal” apar doar în Safari normal pe iPhone/iPad. */
export function setupInstallHint(el: HTMLElement, closeBtn: HTMLButtonElement): void {
  const p = detectPlatform(navigator as Navigator & { standalone?: boolean }, matchMedia('(display-mode: standalone)').matches || matchMedia('(display-mode: fullscreen)').matches);
  let dismissed = false;
  try {
    dismissed = localStorage.getItem(DISMISS_KEY) === '1';
  } catch {
    dismissed = false;
  }
  el.hidden = !shouldShowInstallHint(p, dismissed);
  closeBtn.addEventListener('click', () => {
    el.hidden = true;
    try {
      localStorage.setItem(DISMISS_KEY, '1');
    } catch {
      /* stocare indisponibilă în navigarea privată */
    }
  });
}

/** Permisiunea pentru senzorul de înclinare (iOS) se cere doar dintr-o atingere. */
export async function requestTiltPermission(): Promise<'granted' | 'denied' | 'unsupported'> {
  const DOE = (window as unknown as { DeviceOrientationEvent?: { requestPermission?: () => Promise<string> } }).DeviceOrientationEvent;
  if (!DOE) return 'unsupported';
  if (typeof DOE.requestPermission !== 'function') return 'granted';
  try {
    return (await DOE.requestPermission()) === 'granted' ? 'granted' : 'denied';
  } catch {
    return 'denied';
  }
}
